export const translation = {
  "en": {
      "m0001": "Sales by product group",
      "m0002": "YTD gross profit comparison and growth",
      "m0003": "Inventory mix by turnover rate",
      "m0004": "Home",
      "m0005": "Filter by ...",
      "m0006": "Dashboard",
      "m0007": "Dealership",
      "m0008": "Report Group",
      "m0009": "View All",
      "m0010": "No data available to show.",
      "m0011": "%space%suggested items to purchase",
      "m0012": "PO Date:",
      "m0013": "N/A",
      "m0017": "Choose a dealership",
      "m0018": "Choose a group",
      "m0019": "Choose a vendor",
      "m0020": "Choose a period",
      "m0021": "Apply",
      "m0022": "Click to drill down",
      "m0023": "Error!",
      "m0024": "Please save changes before export.",
      "m0025": "Unable to fetch details for this org. Please try again.",
      "m0026": "You must set an organization name.",
      "m0027": "You must select an organization type.",
      "m0028": "You must select a country.",
      "m0029": "You must select a state.",
      "m0030": "You must set a language.",
      "m0031": "You must set a currency.",
      "m0032": "updated",
      "m0033": "created",
      "m0034": "The org could not be %action%.",
      "m0035": "The org was %action%!",
      "m0036": "Success!",
      "m0037": "Organization Type:*",
      "m0038": "Vendor:",
      "m0039": "Parent Org(s):",
      "m0040": "Inactive:",
      "m0041": "Allow suggested orders to be edited:",
      "m0042": "State:*",
      "m0043": "Country:*",
      "m0044": "Time Zone:",
      "m0045": "Language:*",
      "m0046": "Currency:*",
      "m0047": "Organization Name",
      "m0048": "Org Code",
      "m0049": "Org Number",
      "m0050": "Notes",
      "m0051": "Address (Line 1)",
      "m0052": "Address (Line 2)",
      "m0053": "City",
      "m0054": "Postal Zip",
      "m0055": "Phone",
      "m0056": "Email",
      "m0057": "Fax",
      "m0058": "Website",
      "m0059": "Contact Info",
      "m0060": "Modify Org",
      "m0061": "Create Org",
      "m0062": "General Org Configuration",
      "m0063": "Address",
      "m0064": "Contact Information",
      "m0065": "Localization",
      "m0066": "You must specify a first name.",
      "m0067": "You must specify a last name.",
      "m0068": "You must specify an email address.",
      "m0069": "You must choose at least one role.",
      "m0070": "You must choose an org.",
      "m0071": "The user was sucessfully %action%!",
      "m0072": "Heads up!",
      "m0073": "We have just fired off a welcome email to %var1% %var2%...",
      "m0074": "The email could not be sent off!",
      "m0075": "Close the window and use the Send Welcome Email button.",
      "m0076": "Modify User Record",
      "m0077": "Create User Record",
      "m0078": "First Name",
      "m0079": "Last Name",
      "m0080": "Email",
      "m0081": "Inactive:",
      "m0082": "Send welcome",
      "m0083": "email?",
      "m0084": "Org:",
      "m0085": "Role(s):*",
      "m0086": "Unable to retrieve list of super admins.",
      "m0087": "There was a problem in fetching the list of users. Please try again.",
      "m0088": "We failed to send out the email. Please try again.",
      "m0089": "Manage Users",
      "m0090": "Manage Orgs",
      "m0091": "Manage Users for %var1%",
      "m0092": "Manage Users with the role %var1%",
      "m0093": "Create New User",
      "m0094": "Role",
      "m0095": "Inactive",
      "m0096": "Registered",
      "m0097": "Edit User",
      "m0098": "Send Welcome Email",
      "m0099": "Are you sure you want to send a welcome email to  %var1% %var2%?",
      "m0100": "This person will be forced to re-register for an account. Until then his/her access to SOM will be taken away.",
      "m0101": "Cancel",
      "m0102": "Org Name",
      "m0103": "Org Type",
      "m0104": "Country",
      "m0105": "No data to show here!",
      "m0106": "Unable to get the list of orgs. Please try again.",
      "m0107": "Attempting to log you into %var1% ...",
      "m0108": "Unable to log you into %var1%. Please try again.",
      "m0109": "Unable to log you into the org. Please try again.",
      "m0110": "Create new org",
      "m0111": "Edit",
      "m0112": "Log in to this org",
      "m0113": "Your passwords need to match",
      "m0114": "Your passwords do not meet the minimum complexity requirements.",
      "m0115": "The passowrd could not be changed. Please try again.",
      "m0116": "The password was sucessfully changed.",
      "m0117": "Your password has been sucessfully changed.",
      "m0118": "Head back to the portal.",
      "m0119": "Change Password",
      "m0120": "Please enter your new password.",
      "m0121": "Password",
      "m0122": "Re-enter your password",
      "m0123": "Password must contain a minimum of 8 characters including at least one lowercase character, one uppercase, one number, and one special character.",
      "m0124": "",
      "m0125": "",
      "m0126": "",
      "m0127": "",
      "m0128": "You need to specify a reporting period.",
      "m0129": "Unable to display KPI summary data.",
      "m0130": "Unable to display Inventory Mix data.",
      "m0131": "Unable to display YTD Gross Profit Comparison data.",
      "m0132": "Unable to display Sales by Product Group data.",
      "m0133": "Unable to retrieve dashboard data. Please try again.",
      "m0134": "Unable to retrieve part exception of %var1%. Please try again.",
      "m0135": "You must select an adjustment reason.",
      "m0136": "Minimum stocking qty cannot be greater than maximum stocking qty.",
      "m0137": "You must select a season if you set in-season minimum qty.",
      "m0138": "set",
      "m0139": "deleted",
      "m0140": "The exception was %action%!",
      "m0141": "The exception could not be %action%.",
      "m0142": "Exception settings",
      "m0143": "Part Number:%space%",
      "m0144": "Vendor:%space%",
      "m0145": "Changes to these settings will affect future suggested orders, but not the current one.",
      "m0146": "Minimum stocking qty",
      "m0147": "Min expiry date",
      "m0148": "Maximum stocking qty",
      "m0149": "Max expiry date",
      "m0150": "Season",
      "m0151": "In-season minimum qty",
      "m0152": "Never order this item again",
      "m0153": "Adjustment reason",
      "m0154": "Warning",
      "m0155": "This part %var1% is marked as Never Order, all other settings will be cleared.",
      "m0156": "Are you sure you want to continue?",
      "m0157": "You must set season name.",
      "m0158": "You must set start month. !DEVNsOTE! Action status reason",
      "m0159": "You must set start day.",
      "m0160": "You must set end month.",
      "m0161": "You must set end day.",
      "m0162": "The season was %action%!",
      "m0163": "The season could not be %action%.",
      "m0164": "Season settings",
      "m0165": "Season Name:*",
      "m0166": "Start month:*",
      "m0167": "Start day:*",
      "m0168": "End month:*",
      "m0169": "End day:*",
      "m0170": "Saving the season %var1% as inactive will remove the season settings for all parts assigned to the season.",
      "m0171": "The inventory shaping rule was sucessfully deleted!",
      "m0172": "The The inventory shaping rule could not be deleted. Please try again.",
      "m0173": "The rule has been deleted.",
      "m0174": "Are you sure you want to delete this rule?",
      "m0175": "Close",
      "m0176": "Yes",
      "m0177": "You must choose between either a minimum or maximum threshold.",
      "m0178": "You must enter an inventory threshold value.",
      "m0179": "You must enter a part number.",
      "m0180": "You can't set expiry date to be before today.",
      "m0181": "You can't set effective date to be before today.",
      "m0182": "This inventory shaping rule was successfully %action%!",
      "m0183": "The part number does not exist",
      "m0184": "We could not verify whether the part number exists.",
      "m0185": "Create Inventory Rule",
      "m0186": "Modify Inventory Rule",
      "m0187": "For which part number(s)?",
      "m0188": "Are you setting a minimum or maximum inventory threshold?",
      "m0189": "Minimum",
      "m0190": "Maximum",
      "m0191": "Part Number",
      "m0192": "Inventory Threshold",
      "m0193": "Set rule effective date:",
      "m0194": "Set rule expiry date:",
      "m0195": "ROI %",
      "m0196": "%space%greater than or equal to",
      "m0197": "Special Order %",
      "m0198": "%space%less than or equal to",
      "m0199": "Actual",
      "m0200": "Dealer Name",
      "m0201": "ROI Target: = %var1% %",
      "m0202": "Goal Met?",
      "m0203": "No ROI target set",
      "m0204": "Special Order Target: = %var1% %",
      "m0205": "No Special Order target set",
      "m0206": "Unable to retrieve the list of shaping rules.",
      "m0207": "Inventory Shaping",
      "m0208": "Showing your order shaping rules by",
      "m0209": "Single dealer",
      "m0210": "Choose a report group",
      "m0211": "Choose a dealership",
      "m0212": "Create new rule",
      "m0213": "Current Threshold",
      "m0214": "ROI Goal Met",
      "m0215": "Special Order Goal Met",
      "m0216": "Active For",
      "m0217": "Effective Date",
      "m0218": "Expiry Date",
      "m0219": "Delete Rule",
      "m0220": "Login",
      "m0221": "Logged out",
      "m0222": "You have been successfully logged out of the system.",
      "m0223": "Access denied",
      "m0224": "Sorry, you don't have access to this part of the site. Log in and try again.",
      "m0225": "Suggested Order Management",
      "m0226": "SOM",
      "m0227": "Login",
      "m0228": "Go back to the login page.",
      "m0229": "That means page not found.",
      "m0230": "Go back to the previous page.",
      "m0231": "... or ...",
      "m0232": "Go back to the login page.",
      "m0233": "The report group was successfully deleted.",
      "m0234": "The report group could not be deleted. Please try again.",
      "m0235": "Do you want to delete this report group?",
      "m0236": "There are no organizations under this reporting group.",
      "m0237": "Report Group Management",
      "m0238": "Create new group",
      "m0239": "Please Confirm",
      "m0240": "You must specify a name for this group.",
      "m0241": "You must include at least one dealership in this group.",
      "m0242": "The organization group was successfully %action%!",
      "m0243": "Create Report Group",
      "m0244": "Modify Report Group",
      "m0245": "Enter group name and select stores for this group.",
      "m0246": "Select stores for this group.",
      "m0247": "Report Group Name:",
      "m0248": "Store Number",
      "m0249": "Organization Name",
      "m0250": "Unable to retrieve part demand details of %var1%. Please try again.",
      "m0251": "Would you like to save your changes?",
      "m0252": "Save",
      "m0253": "Exit without saving",
      "m0254": "parts/pkg",
      "m0255": "By%space%",
      "m0256": "Min qty%space%",
      "m0257": "Part number",
      "m0258": "Description",
      "m0259": "Vendor",
      "m0260": "Avail",
      "m0261": "Sold",
      "m0262": "Stock min",
      "m0263": "Min expire",
      "m0264": "Stock max",
      "m0265": "Max expire",
      "m0266": "Season",
      "m0267": "Never order",
      "m0268": "Modified",
      "m0269": "All Exceptions",
      "m0270": "You must specify a part number or an exception in search filter.",
      "m0271": "Unable to retrieve part exceptions. Please try again.",
      "m0272": "You must select an adjustment reason for part number %var1%!",
      "m0273": "Warning!",
      "m0274": "No record is modified.",
      "m0275": "The %var1% part exception(s) have been successfully updated.",
      "m0276": "Part Exceptions",
      "m0277": "Here are the results based on your filters",
      "m0278": "Edit",
      "m0279": "Settings",
      "m0280": "Details",
      "m0281": "Demand",
      "m0282": "Effective Date",
      "m0283": "Old Part #",
      "m0284": "New Part #",
      "m0285": "No details to show.",
      "m0286": "Location",
      "m0287": "Qty Available",
      "m0288": "Qty Sales In Progress",
      "m0289": "Qty Sold",
      "m0290": "Status",
      "m0291": "Unable to fetch details for this part number.",
      "m0292": "You must specify a part number.",
      "m0293": "You must specify a vendor if you also want to check other stores.",
      "m0294": "Unable to retrieve part data. Please try again.",
      "m0295": "Part Lookup",
      "m0296": "Location",
      "m0297": "Unable to get the list of seasons for this dealer. Please try again.",
      "m0298": "Part Seasons",
      "m0299": "Dealer:",
      "m0300": "Create new season",
      "m0301": "Season Name",
      "m0302": "Start Month",
      "m0303": "Start Day",
      "m0304": "End Month",
      "m0305": "End Day",
      "m0306": "Your email isn't properly formatted. Try again.",
      "m0307": "Your password has not met the minimum requirements.",
      "m0308": "The user account could not be registered. Please ensure that you have not previously registered this email in the system.",
      "m0309": "Now please check your email to verify your account.",
      "m0310": "Register",
      "m0311": "For SOM pre-authorized users only!",
      "m0312": "Password must contain a minimum of 8 characters including at least one lowercase character, one uppercase, one number, and one special character.",
      "m0313": "Create Account",
      "m0314": "Suggested Qty",
      "m0315": "Order Qty",
      "m0316": "Pkg",
      "m0317": "Units/Pkg",
      "m0318": "Cost",
      "m0319": "There is no data to show here.",
      "m0320": "Part Description",
      "m0321": "Quantity Available",
      "m0322": "Total Value",
      "m0323": "Quantity Sold",
      "m0324": "Last Sold Date",
      "m0325": "Last Month Revenue",
      "m0326": "Last Month Profit",
      "m0327": "Aged Inventory",
      "m0328": "Inventory Turnover Rate",
      "m0329": "GMROI",
      "m0330": "Aged Value",
      "m0331": "Order Date",
      "m0332": "Vendor Code",
      "m0333": "Total Items",
      "m0334": "Dealer Number",
      "m0335": "Inventory Value",
      "m0336": "Aged Percent",
      "m0337": "Obsolete Percent",
      "m0338": "Obsolete Value",
      "m0339": "Slow Moving Percent",
      "m0340": "Slow Moving Value",
      "m0341": "Average Moving Percent",
      "m0342": "Average Moving Value",
      "m0343": "Fast Moving Percent",
      "m0344": "Fast Moving Value",
      "m0345": "Total Qty Sold",
      "m0346": "Qty Refunded",
      "m0347": "Qty Special Ordered",
      "m0348": "Current Qty Available",
      "m0349": "Current Qty On Order",
      "m0350": "Current Qty In Progress",
      "m0351": "Product Group",
      "m0352": "Date",
      "m0353": "User Name",
      "m0354": "Logins",
      "m0355": "Order Views",
      "m0356": "CSV Order Exports",
      "m0357": "XLS Order Exports",
      "m0358": "API Order Exports",
      "m0359": "Never Orders",
      "m0360": "Order Quantity Edits",
      "m0361": "Stocking Edits",
      "m0362": "Report Views",
      "m0363": "Org ID",
      "m0364": "Vendor Name",
      "m0365": "Submitted on From",
      "m0366": "Submitted on To",
      "m0367": "Ordered from Suggested Parts Qty %",
      "m0368": "Ordered from Suggested Parts Value %",
      "m0369": "SOM Suggested Portion of PO Total Value %",
      "m0370": "Unable to retrieve list of admin report url.",
      "m0371": "Unable to retrieve report data. Please try again.",
      "m0372": "Unable to retrieve list of admin reports.",
      "m0373": "Total Sales",
      "m0374": "Total Sales Hit",
      "m0375": ".xls Export",
      "m0377": "Unable to retrieve list of admin reports.",
      "m0378": "Unable to retrieve list of reports.",
      "m0379": "Reports",
      "m0380": "Admin Reports",
      "m0381": "Admin reports",
      "m0382": "Please select part(s) to add.",
      "m0383": "%var1% parts selected",
      "m0384": "%var1% part selected",
      "m0385": "Apply",
      "m0386": "Selected",
      "m0387": "Add Selected Parts",
      "m0388": "Inventory Value",
      "m0389": "Total inventory value at the end of last full business day of selected month",
      "m0390": "This Month Sales",
      "m0391": "Total sales revenue at the end of last full business day of selected month",
      "m0392": "This Month Gross Profit",
      "m0393": "Total gross profit of the selected month which is calculated by deducting Cost of Goods Sold from Total Sales Revenue of the selected month",
      "m0394": "Aged Inventory",
      "m0395": "Total inventory value of parts that didn't have any sales in past 12 months excluding obsolete parts and parts added to the catalog less than 12 months ago, as of end of the last full business day of selected month",
      "m0396": "Obsolete Inventory",
      "m0397": "Inventory value of obsolete parts at the end of last full business day of selected month",
      "m0398": "YTD Gross Profit",
      "m0399": "Cumulative year to date gross profit at the end of last full business day of selected month",
      "m0400": "GMROI",
      "m0401": "Gross Margin Return On Investment which is calculated by dividing Gross Margin by Average Inventory Cost. **NOTE: Average Inventory Cost is ideally calculated over 12 months period by dividing the sum of the Ending inventory value of each month by 12. When less than 12 months of inventory values is provided an estimated value is calculated.",
      "m0402": "Inventory Turnover Rate",
      "m0403": "Inventory Turnover Rate is calculated by dividing Cost of Goods Sold by Average Inventory Cost. **NOTE: Average Inventory Cost is ideally calculated over 12 months period by dividing the sum of the Ending inventory value of each month by 12. When less than 12 months of inventory values is provided an estimated value is calculated.",
      "m0404": "Is there a way to manually change SOM-suggested orders?",
      "m0405": "SOM is an intelligent, self-evaluating system that uses advanced algorithms to generate suggested orders for precisely the right parts, in the perfect quantity, for you. The key word here is%space%",
      "m0406": "How does SOM account for my busy and slow seasons?",
      "m0407": "SOM automatically detects part seasonality, based on historical sales, demand patterns, and current sales trend. It extrapolates that information into a sales forecast for a configurable period that makes sense for your business. SOM then adjusts inventory levels accordingly and helps your business ease in and out of high and low seasons without you suffering from under/overstock issues.",
      "m0408": "How are superseded and obsolete parts handled in SOM?",
      "m0409": "SOM will not suggest obsolete parts in an order, nor old parts in the superseded parts chain, as long as the OEM provides regular parts updates.",
      "m0410": "How does SOM work with part package quantities?",
      "m0411": "SOM respects OEM part ordering requirements for packaged parts or parts with defined MOQ. SOM-suggested orders automatically reflect OEM requirements. For packaged parts, the quantity value represents the number of packages to order; otherwise, it indicates the number of individual parts to order.",
      "m0412": "How can I use SOM-suggested orders in my DMS?",
      "m0413": "In Super SOM you can export current suggested order into an Excel or CSV file format.",
      "m0414": "The Excel file format includes a part number, description, order quantity, package part indicator, package quantity, cost, and total cost. This format is useful for those who prefer to enter suggested orders into the DMS manually.",
      "m0415": "The CSV file includes only a part number and order quantity (",
      "m0416": "Is there a way to make SOM ignore exceptional sales?",
      "m0417": "An exceptional sale is one that is considered \"above and beyond\" regular sales activity. Super SOM algorithms will ignore them, but only if they are marked as exceptional in your DMS.",
      "m0418": "Can I permanently exclude a part from SOM suggested orders?",
      "m0419": "Yes. You can flag the part as “Non-Stock” in your DMS, or flag it (Never Order checkbox) in SOM part exceptions settings.",
      "m0420": "How often should I use SOM suggested orders?",
      "m0421": "SOM is capable of generating suggested orders daily if desired. Optimal frequency, however, depends on your business and your typical full-cycle lead-time for order submission through shipment, receiving, and stocking of parts. For example, if your usual lead-time is two weeks, we suggest a weekly or bi-weekly order, to ensure availability of stock and to stay on top of parts with an uptrend in demand.",
      "m0422": "Videos",
      "m0423": "Need support? Contact us at",
      "m0424": "and we'll be happy to help.",
      "m0425": "Support",
      "m0426": "Qty",
      "m0427": "Session Expiring",
      "m0428": "Your session is about to expire in under 5 minutes.",
      "m0429": "Do you want to continue using this application?",
      "m0430": "End my session",
      "m0431": "Unable to get the list of vendors for this dealer. Please try again.",
      "m0432": "Select a vendor to view its list of suggested items.",
      "m0433": "Dealer:",
      "m0434": "Loading data...",
      "m0435": "There are no vendors with suggested items.",
      "m0436": "GM",
      "m0437": "P&A",
      "m0438": "All Parts",
      "m0439": "Suggested Order - %var1%",
      "m0440": "Part #",
      "m0441": "On order",
      "m0442": "Suggested",
      "m0443": "There were no suggested orders to show for this vendor.",
      "m0444": "Available:",
      "m0445": "- On Order:",
      "m0446": "- Sold:",
      "m0447": "The %var1% suggested order part(s) have been successfully updated.",
      "m0448": "Line Items:",
      "m0449": "Total Units:",
      "m0450": "Total Value:",
      "m0451": "Date Generated:",
      "m0452": "This is the suggested purchase order for",
      "m0453": "Add Part",
      "m0456": "Log Out",
      "m0457": "Manage orgs",
      "m0458": "Manage superadmins",
      "m0459": "Hang in there! We will be in touch shortly",
      "m0460": "Support",
      "m0461": "Admin",
      "m0462": "User management",
      "m0463": "Dashboard",
      "m0464": "Suggested order",
      "m0465": "Report groups",
      "m0466": "Filters",
      "m0467": "Dealership",
      "m0468": "Exception",
      "m0469": "Check other stores?",
      "m0470": "Exception:",
      "m0471": "Country:",
      "m0472": "Org Type:",
      "m0473": "Org:",
      "m0474": "Period:",
      "m0475": "Part Group:",
      "m0476": "Dealership:",
      "m0477": "Report Group:",
      "m0478": "Select a dealership",
      "m0479": "Start Date:",
      "m0480": "End Date:",
      "m0481": "Start Date",
      "m0482": "End Date",
      "m0483": "You must select the part group filter!",
      "m0484": "You must select the order type filter!",
      "m0485": "You must type in the part number!",
      "m0486": "You must select the exception filter!",
      "m0487": "You must select the country filter!",
      "m0488": "You must select the org type filter!",
      "m0489": "You must select the org filter!",
      "m0490": "You must select the period filter!",
      "m0491": "You must specify a start date!",
      "m0492": "The end date must come after the start date!",
      "m0493": "You must choose a vendor!",
      "m0494": "You must choose either a dealership or report group!",
      "m0495": "You must select a dealership!",
      "m0496": "You must select a report group!",
      "m0497": "Modal can't be closed.",
      "m0498": "You have to choose one of the options below.",
      "m0499": "Your session is about to expire in under 5 minutes.",
      "m0500": "Do you want to continue using this application?",
      "m0501": "End my session",
      "m0502": "Continue session",
      "m0503": "Create record",
      "m0504": "Export for DMS Import",
      "m0505": "Close window",
      "m0506": "Show excluded parts",
      "m0507": "Reset settings",
      "m0508": "Add",
      "m0509": ".xls Export",
      "m0510": "Year",
      "m0511": "Top 100 parts with highest quantity sold in selected time interval.",
      "m0512": "Lists all organizations in user’s scope ordered from highest performer to the lowest based on combined ranking of monthly KPI values.",
      "m0513": "Lists all organizations in user’s scope sorted from the highest aged inventory value to the lowest.",
      "m0514": "Lists all Suggested Orders in selected time interval for all organizations in user’s scope.",
      "m0515": "Top 100 parts that are aged, obsolete, or have low turnover rate, sorted by highest inventory value and/or qty. In case of multiple organization view, number of organizations in user’s scope carrying the part is also considered in ranking.",
      "m0516": "Parts that didn't have any sales in last 12 months, sorted by highest inventory value and/or qty. In case of multiple organization view, number of organizations in user’s scope carrying the part is also considered in ranking.",
      "m0517": "Parts that are flagged obsolete, sorted by highest inventory value and/or qty.",
      "m0518": "Lists inventory mix by percentage for comparison purposes.",
      "m0519": "Lists monthly inventory mix stats history (all available months) for a dealer.",
      "m0520": "A report of part sales statistics within a selected date interval (Default= last 30 days).",
      "m0521": "A report of usage statistics of Super SOM.",
      "m0522": "A report of adoption rate of Super SOM.",
      "m0523": "Top Seller Items",
      "m0524": "Slow Moving Items",
      "m0525": "Top Performers",
      "m0526": "Top Overstocking",
      "m0527": "Suggested Order History",
      "m0528": "Aged Inventory",
      "m0529": "Obsolete Inventory",
      "m0530": "Inventory Mix Comparison",
      "m0531": "Inventory Mix History",
      "m0532": "Part Sales History",
      "m0533": "SOM Usage Stats",
      "m0534": "SOM Adoption",
      "m0535": "Aged Inventory",
      "m0536": "Obsolete",
      "m0537": "Slow Moving",
      "m0538": "Average Moving",
      "m0539": "Fast Moving",
      "m0540": "Profit",
      "m0541": "Inventory value mix of Obsolete parts, Aged Inventory which has not sold any in last 12 month, Slow Moving parts that have sold less than 6 in last 12 month, Average Moving parts that have sold 6 to 24 in last 12 month, Fast Moving parts that have sold more than 24 in last 12 month",
      "m0542": "Year-To-Date Profit Comparison is comparing profit of each month of current year represented by blue bars to the profit made on the same month of previous year represented by green bars and the positive or negative growth percentage is represented by the orange line. If any of the bars missing means that data is not provided or the month is yet to finish.",
      "m0543": "Sales revenue of the selected month by two main part groups of General Merchandise (GM) and Parts & Accessories (P&A)",
      "m0544": "Growth",
      "m0545": "Select Part",
      "m0546": "suggested",
      "m0547": "%space%— you can change the order before submitting it. But we strongly recommend ordering as suggested. SOM’s ever-increasing precision will solidify your trust with every order.  You can change the part order quantity in the current SOM-suggested order by altering the value displayed in the Order Qty column.",
      "m0548": "in packages if applicable",
      "m0549": "). This format is designed to import your suggested order directly into a purchase order within your DMS (",
      "m0550": ").",
      "m0551": "if the CSV file import option is supported on the purchase order screen of your DMS",
      "m0552": "All Vendors",
      "m0553": "All Adjustment Reasons",
      "m0554": "All Roles",
      "m0555": "All Orgs",
      "m0556": "All Countries",
      "m0557": "All Languages",
      "m0558": "All Currencies",
      "m0559": "All Time Zones",
      "m0560": "All States",
      "m0561": "All Org Types",
      "m0562": "All Dealerships",
      "m0563": "All Report Groups",
      "m0564": "All Part Status",
      "m0565": "All Exceptions",
      "m0566": "Never Order",
      "m0567": "Stocking Min/Max",
      "m0568": "Season",
      "m0569": "(All)",
      "m0570": "User",
      "m0571": "Admin",
      "m0572": "Superadmin",
      "m0573": "SO - %var1%",
      "m0574": "No",
      "m0575": "No Return",
      "m0576": "Unable to retrieve part demand details of %var1%. Please try again.",
      "m0577": "<1",
      "m0578": "Qty on order",
      "m0579": "Qty available",
      "m0580": "30 day demand forecast",
      "m0581": "Jan",
      "m0582": "Feb",
      "m0583": "Mar",
      "m0584": "Apr",
      "m0585": "May",
      "m0586": "Jun",
      "m0587": "Jul",
      "m0588": "Aug",
      "m0589": "Sep",
      "m0590": "Oct",
      "m0591": "Nov",
      "m0592": "Dec",
      "m0593": "Total",
      "m0594": "Parts Booking",
      "m0595": "Tool to generate parts bookings",
      "m0596": "Booking & Returns",
      "m0597": "Parts Booking History",
      "m0598": "Previously saved Parts Bookings",
      "m0599": "Unable to save Parts Booking",
      "m0600": "Part Group",
      "m0601": "Edit Parts Booking",
      "m0602": "Unable to delete Parts Booking",
      "m0603": "Delete",
      "m0604": "Do you want to delete this Parts Booking?",
      "m0605": "Parts Return",
      "m0606": "All Categories",
      "m0607": "Part Category:",
      "m0608": "Minimum Cost:",
      "m0609": "Maximum Cost:",
      "m0610": "Max Cost cannot be less than Min Cost!",
      "m0611": "Age (months):",
      "m0612": "You must select the part category filter!",
      "m0613": "You must select the age filter!",
      "m0614": "Minimum Value:",
      "m0615": "Maximum Value:",
      "m0616": "Max Value cannot be less than Min Value!",
      "m0617": "Age (months)",
      "m0618": "Suggested Return Qty",
      "m0619": "Tool to generate parts returns",
  },
  "fr": {
      "m0001": "Ventes par groupe de produits",
      "m0002": "Comparaison et croissance du profit brut annuel cumulatif",
      "m0003": "Inventaire global par taux de rotation",
      "m0004": "Accueil",
      "m0005": "Filtrer par …",
      "m0006": "Tableau de bord",
      "m0007": "Concessionnaire",
      "m0008": "Groupe de rapports",
      "m0009": "Voir tous",
      "m0010": "Aucune donnée disponible.",
      "m0011": "%space%articles suggérés à acheter",
      "m0012": "Date du BC :",
      "m0013": "N/A",
      "m0017": "Choisir un concessionnaire",
      "m0018": "Choisir un groupe",
      "m0019": "Choisir un fournisseur",
      "m0020": "Choisir une période",
      "m0021": "Appliquer",
      "m0022": "Cliquez pour explorer",
      "m0023": "Erreur!",
      "m0024": "Veuillez sauvegarder les changements avant l'exportation.",
      "m0025": "Impossible d'extraire les détails pour cette organisation. Veuillez essayer de nouveau.",
      "m0026": "Vous devez inscrire un nom d'organisation.",
      "m0027": "Vous devez sélectionner un type d'organisation.",
      "m0028": "Vous devez sélectionner un pays.",
      "m0029": "Vous devez sélectionner un état ou une province.",
      "m0030": "Vous devez sélectionner une langue.",
      "m0031": "Vous devez sélectionner une devise.",
      "m0032": "mis(e) à jour",
      "m0033": "créé(e)",
      "m0034": "L'organisation n'a pas pu être",
      "m0035": "L'organisation a été",
      "m0036": "Succès!",
      "m0037": "Type d'organisation :*",
      "m0038": "Fournisseur :",
      "m0039": "Organisation(s) parent :",
      "m0040": "Inactif :",
      "m0041": "Permettre la modification des commandes suggérées :",
      "m0042": "État/Province :*",
      "m0043": "Pays :*",
      "m0044": "Fuseau horaire :",
      "m0045": "Langue :*",
      "m0046": "Devise :*",
      "m0047": "Nom de l'organisation",
      "m0048": "Code de l'organisation",
      "m0049": "Numéro de l'organisation",
      "m0050": "Notes",
      "m0051": "Adresse (Ligne 1)",
      "m0052": "Adresse (Ligne 2)",
      "m0053": "Ville",
      "m0054": "Zip/Code postal",
      "m0055": "Téléphone",
      "m0056": "Courriel",
      "m0057": "Télécopieur",
      "m0058": "Site Web",
      "m0059": "Coordonnées",
      "m0060": "Modifier l'organisation",
      "m0061": "Créer l'organisation",
      "m0062": "Configuration générale de l'organisation",
      "m0063": "Adresse",
      "m0064": "Coordonnées",
      "m0065": "Localisation",
      "m0066": "Vous devez spécifier un prénom.",
      "m0067": "Vous devez spécifier un nom de famille.",
      "m0068": "Vous devez spécifier une adresse courriel.",
      "m0069": "Vous devez choisir au moins un rôle.",
      "m0070": "Vous devez choisir une organisation.",
      "m0071": "L'utilisateur a été %action% avec succès!",
      "m0072": "Attention!",
      "m0073": "Nous venons d'envoyer un courriel de bienvenue à %var1% %var2%...",
      "m0074": "Le courriel n'a pas pu être envoyé!",
      "m0075": "Fermez la fenêtre et utilisez le bouton Envoyer un courriel de bienvenue.",
      "m0076": "Modifier le dossier de l'utilisateur",
      "m0077": "Créer le dossier de l'utilisateur",
      "m0078": "Prénom",
      "m0079": "Nom de famille",
      "m0080": "Courriel",
      "m0081": "Inactif :",
      "m0082": "Envoyer un message de bienvenue",
      "m0083": "courriel?",
      "m0084": "Organisation :",
      "m0085": "Rôle(s) :*",
      "m0086": "Impossible de retrouver la liste des super admins.",
      "m0087": "Un problème est survenu lors de la récupération de la liste des utilisateurs. Veuillez essayer de nouveau.",
      "m0088": "L'envoi du courriel a échoué. Veuillez essayer de nouveau.",
      "m0089": "Gestion des utilisateurs",
      "m0090": "Gestion des organisations",
      "m0091": "Gérer les utilisateurs pour %var1%",
      "m0092": "Gérer les utilisateurs avec le rôle %var1%",
      "m0093": "Créer un nouvel utilisateur",
      "m0094": "Rôle",
      "m0095": "Inactif",
      "m0096": "Enregistré",
      "m0097": "Modifier l'utilisateur",
      "m0098": "Envoyer un courriel de bienvenue",
      "m0099": "Êtes-vous certain de vouloir envoyer un courriel de bienvenue à %var1% %var2%?",
      "m0100": "Cette personne devra s'enregistrer de nouveau pour un compte. D'ici là, son accès à SOM lui sera retiré.",
      "m0101": "Annuler",
      "m0102": "Nom d'organisation",
      "m0103": "Type d'organisation",
      "m0104": "Pays",
      "m0105": "Aucune donnée à afficher ici!",
      "m0106": "Impossible d'obtenir la liste des organisations. Veuillez essayer de nouveau.",
      "m0107": "Tentative de connexion à %var1% …",
      "m0108": "Impossible de vous connecter à %var1%. Veuillez essayer de nouveau.",
      "m0109": "Impossible de vous connecter à l'organisation. Veuillez essayer de nouveau.",
      "m0110": "Créer une nouvelle organisation",
      "m0111": "Modifier",
      "m0112": "Se connecter à cette organisation",
      "m0113": "Vos mots de passe doivent être identiques",
      "m0114": "Vos mots de passe ne rencontrent pas les exigences minimales de complexité.",
      "m0115": "Le mot de passe ne peut pas être modifié. Veuillez essayer de nouveau.",
      "m0116": "Le mot de passe a été modifié avec succès.",
      "m0117": "Votre mot de passe a été modifié avec succès.",
      "m0118": "Retournez au portail.",
      "m0119": "Modifier le mot de passe",
      "m0120": "Veuillez entrer votre nouveau mot de passe.",
      "m0121": "Mot de passe",
      "m0122": "Entrez votre mot de passe de nouveau",
      "m0123": "Le mot de passe doit contenir au moins 8 caractères dont au moins une minuscule, une majuscule, un chiffre et un caractère spécial.",
      "m0124": "",
      "m0125": "",
      "m0126": "",
      "m0127": "",
      "m0128": "Vous devez spécifier une période pour le rapport.",
      "m0129": "Impossible d'afficher les données sommaires de KPI.",
      "m0130": "Impossible d'afficher les données d'inventaire global",
      "m0131": "Impossible d'afficher les données de comparaison du profit brut annuel cumulatif.",
      "m0132": "Impossible d'afficher les données de ventes par groupe de produits.",
      "m0133": "Impossible de retrouver les données du tableau de bord. Veuillez essayer de nouveau.",
      "m0134": "Impossible de retrouver les exceptions de pièces de %var1%. Veuillez essayer de nouveau.",
      "m0135": "Vous devez sélectionner une raison d'ajustement.",
      "m0136": "La quantité minimale de stock ne peut pas être supérieure à la quantié maximale de stock.",
      "m0137": "Vous devez sélectionner une saison si vous définissez une quantié minimale de saison.",
      "m0138": "définie",
      "m0139": "supprimée",
      "m0140": "L'exception a été %action%!",
      "m0141": "L'exception n'a pas pu être %action%.",
      "m0142": "Paramètres d'exception",
      "m0143": "Numéro de pièces :%space%",
      "m0144": "Fournisseur :%space%",
      "m0145": "Des modifications à ces paramètres affecteront les commandes suggérées futures, mais pas celle en cours.",
      "m0146": "Qté stock minimale",
      "m0147": "Date exp. min.",
      "m0148": "Qté stock maximale",
      "m0149": "Date exp. max.",
      "m0150": "Saison",
      "m0151": "Qté minimale de saison",
      "m0152": "Ne jamais commander cet article de nouveau",
      "m0153": "Raison d'ajustement",
      "m0154": "Avertissement",
      "m0155": "Cette pièce %var1% est identifiée comme Ne jamais commander, tous les autres paramètres seront effacés.",
      "m0156": "Êtes-vous certain de vouloir continuer?",
      "m0157": "Vous devez définir un nom de saison",
      "m0158": "Vous devez définir un mois de début. !DEVNsOTE! Raison de statut d'action",
      "m0159": "Vous devez définir un jour de début.",
      "m0160": "Vous devez définir un mois de fin.",
      "m0161": "Vous devez définir un jour de fin.",
      "m0162": "La saison a été %action%!",
      "m0163": "La saison n'a pas pu être %action%.",
      "m0164": "Paramètres de saison",
      "m0165": "Nom de saison :*",
      "m0166": "Mois de début :*",
      "m0167": "Jour de début :*",
      "m0168": "Mois de fin :*",
      "m0169": "Jour de fin :*",
      "m0170": "Sauvegarder la saison %var1% comme inactive effacera les paramètres de saison pour toutes les pièces assignées à la saison.",
      "m0171": "La règle de mise en forme de l'inventaire a été supprimée avec succès!",
      "m0172": "La règle de mise en forme de l'inventaire n'a pas pu été supprimée. Veuillez essayer de nouveau.",
      "m0173": "La règle a été supprimée.",
      "m0174": "Êtes-vous certain de vouloir supprimer cette règle?",
      "m0175": "Fermer",
      "m0176": "Oui",
      "m0177": "Vous devez choisir un seuil minimal ou maximal.",
      "m0178": "Vous devez entrer une valeur de seuil d'inventaire.",
      "m0179": "Vous devez entrer un numéro de pièce.",
      "m0180": "Vous ne pouvez pas définir une date d'expiration avant la date d'aujourd'hui.",
      "m0181": "Vous ne pouvez pas définir une date d'entrée en vigueur avant la date d'aujourd'hui.",
      "m0182": "La règle de mise en forme de l'inventaire a été %action%! avec succès!",
      "m0183": "Le numéro de pièce n'existe pas",
      "m0184": "Nous n'avons pas pu vérifier si le numéro de pièce existe.",
      "m0185": "Créer la règle d'inventaire",
      "m0186": "Modifier la règle d'inventaire",
      "m0187": "Pour quel(s) numéro(s) de pièce?",
      "m0188": "Définissez-vous un seuil d'inventaire minimal ou maximal?",
      "m0189": "Minimum",
      "m0190": "Maximum",
      "m0191": "Numéro de pièce",
      "m0192": "Seuil d'inventaire",
      "m0193": "Définir la date d'entrée en vigueur de la règle :",
      "m0194": "Définir la date d'expiration de la règle :",
      "m0195": "RCI %",
      "m0196": "%space%plus grand ou égal à",
      "m0197": "Commande spéciale %",
      "m0198": "%space%plus petit ou égal à",
      "m0199": "Réel",
      "m0200": "Nom du concessionnaire",
      "m0201": "Cible RCI : = %var1% %",
      "m0202": "Objectif atteint?",
      "m0203": "Aucune cible RCI définie",
      "m0204": "Cible de commande spéciale : = %var1% %",
      "m0205": "Aucune cible de commande spéciale définie",
      "m0206": "Impossible de retrouver la liste de règles de mise en forme.",
      "m0207": "Mise en forme de l'inventaire",
      "m0208": "Afficher vos règles de mise en forme de commande par",
      "m0209": "Concessionnaire unique",
      "m0210": "Choisir un groupe de rapports",
      "m0211": "Choisir un concessionnaire",
      "m0212": "Créer une nouvelle règle",
      "m0213": "Seuil actuel",
      "m0214": "Objectif RCI atteint",
      "m0215": "Objectif de commande spéciale atteint",
      "m0216": "Actif(ve) pour",
      "m0217": "Date d'entrée en vigueur",
      "m0218": "Date d'expiration",
      "m0219": "Supprimer la règle",
      "m0220": "Connexion",
      "m0221": "Déconnecté",
      "m0222": "Vous avez été déconnecté du système avec succès.",
      "m0223": "Accès refusé",
      "m0224": "Désolé, vous n'avez pas accès à cette section du site. Connectez-vous et essayez de nouveau.",
      "m0225": "Gestion de commandes suggérées",
      "m0226": "SOM",
      "m0227": "Connexion",
      "m0228": "Retournez à la page de connexion.",
      "m0229": "Cela signifie que la page est introuvable.",
      "m0230": "Retournez à la page précédente.",
      "m0231": "... ou ...",
      "m0232": "Retournez à la page de connexion.",
      "m0233": "Le groupe de rapports a été supprimé avec succès.",
      "m0234": "Le groupe de rapports n'a pas pu être supprimé. Veuillez essayer de nouveau.",
      "m0235": "Voulez-vous supprimer ce groupe de rapports?",
      "m0236": "Il n'y a pas d'organisation sous ce groupe de rapports.",
      "m0237": "Gestion de groupe de rapports",
      "m0238": "Créer un nouveau groupe",
      "m0239": "Veuillez confirmer",
      "m0240": "Vous devez spécifier un nom pour ce groupe.",
      "m0241": "Vous devez inclure au moins un concessionnaire dans ce groupe.",
      "m0242": "Le groupe de l'organisation a été %action% avec succès!",
      "m0243": "Créer le groupe de rapports",
      "m0244": "Modifier le groupe de rapports",
      "m0245": "Entrez le nom du groupe et sélectionnez les magasins pour ce groupe.",
      "m0246": "Sélectionnez les magasins pour ce groupe.",
      "m0247": "Nom du groupe de rapports :",
      "m0248": "Numéro de magasin",
      "m0249": "Nom de l'organisation",
      "m0250": "Impossible de retrouver les détails de demande de la pièce %var1%. Veuillez essayer de nouveau.",
      "m0251": "Voulez-vous sauvegarder vos modifications?",
      "m0252": "Sauvegarder",
      "m0253": "Quitter sans sauvegarder",
      "m0254": "pièces/paquet",
      "m0255": "Par%space%",
      "m0256": "Qté min%space%",
      "m0257": "Numéro de pièce",
      "m0258": "Description",
      "m0259": "Fournisseur",
      "m0260": "Dispo",
      "m0261": "Vendue",
      "m0262": "Stock min",
      "m0263": "Min expire",
      "m0264": "Max stock",
      "m0265": "Max expire",
      "m0266": "Saison",
      "m0267": "Ne jamais commander",
      "m0268": "Modifié(e)",
      "m0269": "Toutes les exceptions",
      "m0270": "Vous devez spécifier un numéro de pièce ou une exception dans le filtre de recherche.",
      "m0271": "Impossible de retrouver les exceptions de pièces. Veuillez essayer de nouveau.",
      "m0272": "Vous devez sélectionner une raison d'ajustement pour le numéro de pièce %var1%!",
      "m0273": "Avertissement!",
      "m0274": "Aucun dossier n'est modifié.",
      "m0275": "La ou les %var1% exception(s) de pièce ont été modifiée(s) avec succès.",
      "m0276": "Exceptions de pièces",
      "m0277": "Voici les résultats selon vos filtres",
      "m0278": "Modifier",
      "m0279": "Paramètres",
      "m0280": "Détails",
      "m0281": "Demande",
      "m0282": "Date d'entrée en vigueur",
      "m0283": "Ancien numéro de pièce",
      "m0284": "Nouveau numéro de pièce",
      "m0285": "Aucun détail à afficher",
      "m0286": "Emplacement",
      "m0287": "Qté disponible",
      "m0288": "Qté ventes en cours",
      "m0289": "Qté vendue",
      "m0290": "Statut",
      "m0291": "Impossible de retrouver les détails pour ce numéro de pièce.",
      "m0292": "Vous devez spécifier un numéro de pièce.",
      "m0293": "Vous devez spécifier un fournisseur si vous désirez également vérifier d'autres magasin.",
      "m0294": "Impossible de retrouver les données de la pièce. Veuillez essayer de nouveau.",
      "m0295": "Recherche de pièce",
      "m0296": "Emplacement",
      "m0297": "Impossible d'avoir la liste de saisons pour ce concessionnaire. Veuillez essayer de nouveau.",
      "m0298": "Saisons de pièce",
      "m0299": "Concessionnaire :",
      "m0300": "Créer une nouvelle saison",
      "m0301": "Nom de saison",
      "m0302": "Mois de début",
      "m0303": "Jour de début",
      "m0304": "Mois de fin",
      "m0305": "Jour de fin",
      "m0306": "Vous n'avez pas le bon format pour votre courriel. Essayer de nouveau.",
      "m0307": "Votre mot de passe n'a pas rencontré les exigences minimales.",
      "m0308": "Le compte de l'utilisateur n'a pas pu être enregistré. Veuillez vous assurer que vous n'avez pas enregistré ce courriel dans le système auparavant.",
      "m0309": "Veuillez maintenant vérifier vos courriels pour valider votre compte.",
      "m0310": "Enregistrer",
      "m0311": "Pour les utilisateurs pré-autorisés de SOM seulement!",
      "m0312": "Le mot de passe doit contenir au moins 8 caractères dont au moins une minuscule, une majuscule, un chiffre et un caractère spécial.",
      "m0313": "Créer le compte",
      "m0314": "Qté suggérée",
      "m0315": "Qté à commander",
      "m0316": "Pqt",
      "m0317": "Unités/Pqt",
      "m0318": "Coût",
      "m0319": "Il n'y a pas de données à afficher ici.",
      "m0320": "Description de pièce",
      "m0321": "Quantité disponible",
      "m0322": "Valeur totale",
      "m0323": "Quantité vendue",
      "m0324": "Dernière date de vente",
      "m0325": "Revenu du dernier mois",
      "m0326": "Profit du dernier mois",
      "m0327": "Inventaire âgé",
      "m0328": "Taux de rotation de l'inventaire",
      "m0329": "MGRCI",
      "m0330": "Valeur âgée",
      "m0331": "Date de commande",
      "m0332": "Code de fournisseur",
      "m0333": "Total d'articles",
      "m0334": "Numéro de concessionnaire",
      "m0335": "Valeur d'inventaire",
      "m0336": "Pourcentage âgé",
      "m0337": "Pourcentage obsolète",
      "m0338": "Valeur obsolète",
      "m0339": "Pourcentage de rotation lente",
      "m0340": "Valeur de rotation lente",
      "m0341": "Pourcentage de rotation moyenne",
      "m0342": "Valeur de rotation moyenne",
      "m0343": "Pourcentage de rotation rapide",
      "m0344": "Valeur de rotation rapide",
      "m0345": "Quantité totale vendue",
      "m0346": "Quantité remboursée",
      "m0347": "Quantité en commande spéciale",
      "m0348": "Quantité actuelle disponible",
      "m0349": "Quantité actuelle en commande",
      "m0350": "Quantité actuelle de ventes en cours",
      "m0351": "Groupe de produit",
      "m0352": "Date",
      "m0353": "Nom d'utilisateur",
      "m0354": "Connexions",
      "m0355": "Affichage de commandes",
      "m0356": "Exportations de commande CSV",
      "m0357": "Exportations de commande XLS",
      "m0358": "Exportations de commande API",
      "m0359": "Ne commande jamais",
      "m0360": "Modifications de quantité en commande",
      "m0361": "Modifications des stocks",
      "m0362": "Affichage de rapports",
      "m0363": "ID de l'organisation",
      "m0364": "Nom de fournisseur",
      "m0365": "Soumis par",
      "m0366": "Soumis à",
      "m0367": "Commandé à partir de qté de pièces suggérées %",
      "m0368": "Commandé à partir de valeur de pièces suggérées %",
      "m0369": "Valeur totale de portion de bon de commande suggérée par SOM",
      "m0370": "Impossible de retrouver l'url du rapport de la liste d'administrateurs.",
      "m0371": "Impossible de retrouver les données du rapport. Veuillez essayer de nouveau.",
      "m0372": "Impossible de retrouver les rapports de la liste d'administrateurs.",
      "m0373": "Ventes totales",
      "m0374": "Ventes totales",
      "m0375": "Exportation .xls",
      "m0377": "Impossible de retrouver les rapports de la liste d'administrateurs.",
      "m0378": "Impossible de retrouver la liste de rapports.",
      "m0379": "Rapports",
      "m0380": "Rapports d'administrateur",
      "m0381": "Rapports d'administrateur",
      "m0382": "Veuillez sélectionner la ou les pièces à ajouter.",
      "m0383": "%var1% pièces sélectionnées",
      "m0384": "%var1% pièce sélectionnée",
      "m0385": "Appliquer",
      "m0386": "Sélectionnée(s)",
      "m0387": "Ajouter les pièces sélectionnées",
      "m0388": "Valeur d'inventaire",
      "m0389": "Valeur totale d'inventaire à la fin du dernier jour ouvrable complet du mois sélectionné",
      "m0390": "Ventes de ce mois",
      "m0391": "Revenu des ventes totales à la fin du dernier jour ouvrable complet du mois sélectionné",
      "m0392": "Profit brut de ce mois",
      "m0393": "Profit brut total du mois sélectionné calculé en déduisant le coût de marchandises vendues du revenu des ventes totales du mois sélectionné",
      "m0394": "Inventaire âgé",
      "m0395": "La valeur d'inventaire des pièces sans ventes dans les 12 derniers mois, excluant les pièces obsolètes et les pièces ajoutées au catalogue il y a moins de 12 mois, à compter de la fin du dernier jour ouvrable complet du mois sélectionné",
      "m0396": "Inventaire obsolète",
      "m0397": "Valeur d'inventaire des pièces obsolètes à la fin du dernier jour ouvrable complet du mois sélectionné",
      "m0398": "Profit brut annuel cumulatif",
      "m0399": "Profit brut annuel cumulatif à la fin du dernier jour ouvrable complet du mois sélectionné",
      "m0400": "MGRCI",
      "m0401": "Marge brute du Rendement du capital investi calculé en divisant la marge brute par le coût moyen d'inventaire. **NOTE : Le coût moyen d'inventaire est idéalement calculé sur une période de 12 mois en divisant la somme de la valeur d'inventaire finale de chaque mois par 12. Lorsque moins de 12 mois de valeurs d'inventaire sont fournies, une valeur approximative est calculée.",
      "m0402": "Taux de rotation de l'inventaire",
      "m0403": "Le taux de rotation de l'inventaire est calculé en divisant le coût des marchandises vendues par le coût moyen d'inventaire. **NOTE : Le coût moyen d'inventaire est idéalement calculé sur une période de 12 mois en divisant la somme de la valeur finale d'inventaire de chaque mois par 12. Lorsque moins de 12 mois de valeurs d'inventaire sont fournies, une valeur approximative est calculée.",
      "m0404": "Y a-t-il une façon de modifier manuellement les commandes suggérées SOM?",
      "m0405": "SOM est un système intelligent et auto-évaluateur qui utilise des algorithmes avancés pour générer des commandes suggérées pour les bonnes pièces, avec la quantité parfaite, pour vous. Le mot clé ici est%space%",
      "m0406": "Comment SOM tient compte des mes saisons hautes et basses?",
      "m0407": "SOM détecte automatiquement les saisons pour les pièces selon l'historique de ventes, les modèles de demande et la tendance actuelle des ventes. Il extrapole cette information en prévision des ventes pour une période configurable qui a un sens pour votre entreprise. SOM ajuste ensuite les niveaux de stock en conséquence et aide ainsi votre entreprise à facilement faire la transition entre les saisons hautes et les saisons basses sans que vous ayez à souffrir de problèmes de surplus ou de manques de stock.",
      "m0408": "Comment les pièces remplacées et obsolètes sont-elles traitées dans SOM?",
      "m0409": "SOM ne suggèrera pas de pièces obsolètes dans une commande, ni de vieilles pièces dans la chaîne de pièces remplacées, tant et aussi longtemps que le MEO fournit des mises à jour de pièces sur une base régulière. ",
      "m0410": "Comment fonctionne SOM avec les quantités de pièces par paquet?",
      "m0411": "SOM respecte les exigences de commande de pièces des MEO pour les pièces par paquet ou les pièces définies avec une quantité minimale de commande. Les commandes suggérées SOM réflètent automatiquement les exigences des MEO. Pour les pièces par paquet, la quantité représente le nombre de paquets à commander; autrement, elle représente la quantité de pièces individuelles à commander.",
      "m0412": "Comment puis-je utiliser les commandes suggérées SOM avec mon DMS?",
      "m0413": "Dans Super SOM, vous pouvez exporter les commandes suggérées en cours vers un fichier en format Excel ou CSV.",
      "m0414": "Le format de fichier Excel inclut un numéro de pièce, une description, une quantité en commande, un indicateur de pièce par paquet, une quantité de paquet, un coût et un coût total. ",
      "m0415": "Le fichier CSV inclut seulement un numéro de pièce et une quantité en commande (",
      "m0416": "Y a-t-il une façon d'ignorer les ventes exceptionnelles avec SOM?",
      "m0417": "Un vente exceptionnelle est une vente qui est considérée comme n'étant pas dans les normes d'activités de ventes régulières. Les algorithmes de Super SOM les ignoreront, mais seulement si elles sont identifiées comme exceptionnelles dans votre DMS.",
      "m0418": "Est-ce que je peux exclure une pièce des commandes suggérées SOM de façon permanente?",
      "m0419": "Oui. Vous pouvez identifier les pièces comme étant \"Non-stock\" dans votre DMS ou l'identifier (cocher Ne jamais commander) dans les paramètres d'exception de pièces SOM.",
      "m0420": "À quelle fréquence devrais-je utiliser les commandes suggérées SOM?",
      "m0421": "SOM peut générer des commandes suggérées chaque jour si désiré. Par contre, la fréquence optimale dépend de votre entreprise et de votre délai d'approvisionnement sur un cycle complet typique de soumission de commandes, d'expédition, de réception et de stockage des pièces. Par exemple, si votre délai normal est de deux semaines, nous suggérons une commande hebdomadaire ou bihebdomadaire afin d'assurer la disponibilité des stocks et de rester à l'affût des pièces dont la demande est en hausse.",
      "m0422": "Vidéos",
      "m0423": "Besoin de soutien? Contactez-nous au",
      "m0424": "et il nous fera plaisir de vous aider.",
      "m0425": "Soutien",
      "m0426": "Qté",
      "m0427": "Fin de session",
      "m0428": "Votre session se termine dans moins de 5 minutes.",
      "m0429": "Voulez-vous continuer à utiliser cette application?",
      "m0430": "Terminer ma session",
      "m0431": "Impossible d'obtenir la liste des fournisseurs pour ce concessionnaire. Veuillez essayer de nouveau.",
      "m0432": "Sélectionnez un fournisseur afin de voir sa liste d'articles suggérés.",
      "m0433": "Concessionnaire : ",
      "m0434": "Chargement des données...",
      "m0435": "Il n'y a pas de fournisseur avec des articles suggérés.",
      "m0436": "MG",
      "m0437": "P&A",
      "m0438": "Toutes les pièces",
      "m0439": "Commande suggérée - %var1%",
      "m0440": "Numéro de pièce",
      "m0441": "En commande",
      "m0442": "Suggérée",
      "m0443": "Il n'y avait pas de commande suggérée à afficher pour ce fournisseur.",
      "m0444": "Disponible :",
      "m0445": "- En commande :",
      "m0446": "- Vendue :",
      "m0447": "Les %var1% pièces en commande suggérée ont été mises à jour avec succès.",
      "m0448": "Lignes :",
      "m0449": "Total d'unités :",
      "m0450": "Valeur totale :",
      "m0451": "Date de création :",
      "m0452": "Ceci est le bon de commande suggérée pour",
      "m0453": "Ajout pc",
      "m0456": "Fermer la session",
      "m0457": "Gérer les organisations",
      "m0458": "Gérer les super admins",
      "m0459": "Merci de votre patience. Nous communiquerons avec vous sous peu.",
      "m0460": "Soutien",
      "m0461": "Admin",
      "m0462": "Gestion d'utilisateur",
      "m0463": "Tableau de bord",
      "m0464": "Commande suggérée",
      "m0465": "Groupes de rapports",
      "m0466": "Filtres",
      "m0467": "Concessionnaire",
      "m0468": "Exception",
      "m0469": "Vérifier les autres magasins?",
      "m0470": "Exception :",
      "m0471": "Pays :",
      "m0472": "Type d'organisation :",
      "m0473": "Organisation :",
      "m0474": "Période :",
      "m0475": "Groupe de pièces :",
      "m0476": "Concessionnaire :",
      "m0477": "Groupe de rapports :",
      "m0478": "Sélect. concess.",
      "m0479": "Date de début :",
      "m0480": "Date de fin :",
      "m0481": "Date de début",
      "m0482": "Date de fin",
      "m0483": "Vous devez sélectionner un filtre de groupe de pièces!",
      "m0484": "Vous devez sélectionner un filtre de type de commande!",
      "m0485": "Vous devez entrer le numéro de pièce!",
      "m0486": "Vous devez sélectionner un filtre d'exception!",
      "m0487": "Vous devez sélectionner un filtre de pays!",
      "m0488": "Vous devez sélectionner un filtre de type d'organisation!",
      "m0489": "Vous devez sélectionner un filtre d'organisation!",
      "m0490": "Vous devez sélectionner un filtre de période!",
      "m0491": "Vous devez spécifier une date de début!",
      "m0492": "La date de fin doit être postérieure à la date de début!",
      "m0493": "Vous devez sélectionner un fournisseur!",
      "m0494": "Vous devez choisir soit un concessionnaire ou un groupe de rapports!",
      "m0495": "Vous devez sélectionner un concessionnaire!",
      "m0496": "Vous devez sélectionner un groupe de rapports!",
      "m0497": "La boîte de dialogue modale ne peut être fermée.",
      "m0498": "Vous devez choisir une des options ci-dessous.",
      "m0499": "Votre session se termine dans moins de 5 minutes.",
      "m0500": "Voulez-vous continuer à utiliser cette application?",
      "m0501": "Terminer ma session",
      "m0502": "Poursuivre ma session",
      "m0503": "Créer un dossier",
      "m0504": "Export pour import DMS",
      "m0505": "Fermer la fenêtre",
      "m0506": "Afficher les pièces exclues",
      "m0507": "Réini. paramètres",
      "m0508": "Ajouter",
      "m0509": "Export .xls",
      "m0510": "Année",
      "m0511": "Top 100 des pièces avec la plus haute quantité vendue dans un intervalle de temps sélectionné.",
      "m0512": "Liste toutes les organisations dans le périmètre de l'utilisateur, de la plus performante à la moins performante, en se basant sur le classement combiné des valeurs mensuelles des KPI.",
      "m0513": "Liste toutes les organisations dans le périmètre de l'utilisateur, classées de la valeur d'inventaire la plus haute à la plus basse.",
      "m0514": "Liste toutes les commandes suggérées dans un intervalle de temps sélectionné pour toutes les organisations dans le périmètre de l'utilisateur.",
      "m0515": "Top 100 des pièces âgées, obsolètes ou avec un taux de rotation bas, triées par la valeur d'inventaire ou la quantité en stock la plus élevée. Dans le cas d'un affichage de plusieurs organisations, le nombre d'organisations dans le périmètre de l'utilisateur ayant cette pièce est également pris en considération dans le classement.",
      "m0516": "Pièces qui n'ont pas été vendues dans les 12 derniers mois, triées par la valeur d'inventaire ou la quantité en stock la plus élevée. Dans le cas d'un affichage de plusieurs organisations, le nombre d'organisations dans le périmètre de l'utilisateur ayant cette pièce est également pris en considération dans le classement.",
      "m0517": "Pièces marquées obsolètes, triées selon la valeur d'inventaire ou la quantité en stock la plus élevée.",
      "m0518": "Énumère l'inventaire global par pourcentage à des fins de comparaison. ",
      "m0519": "Énumère l'historique des statistiques de l'inventaire global mensuel (tous les mois disponibles) pour un concessionnaire.",
      "m0520": "Un rapport de statistiques de ventes de pièces à l'intérieur d'un intervalle de date sélectionné (Défaut= les derniers 30 jours).",
      "m0521": "Un rapport de statistiques d'utilisation de Super SOM",
      "m0522": "Un rapport de taux d'adoption de Super SOM.",
      "m0523": "Articles meilleurs vendeurs",
      "m0524": "Articles rotation lente",
      "m0525": "Les plus performants",
      "m0526": "Surstockage les plus élevés",
      "m0527": "Historique de commandes suggérées",
      "m0528": "Inventaire âgé",
      "m0529": "Inventaire obsolète",
      "m0530": "Comparaison d'inventaire global",
      "m0531": "Historique d'inventaire global",
      "m0532": "Historique de ventes de pièces",
      "m0533": "Statistiques d'usage de SOM",
      "m0534": "Adoption de SOM",
      "m0535": "Inventaire âgé",
      "m0536": "Obsolète",
      "m0537": "Rotation lente",
      "m0538": "Rotation moyenne",
      "m0539": "Rotation rapide",
      "m0540": "Profit",
      "m0541": "Valeur d'inventaire global de pièces obsolètes et d'inventaire âgé sans vente dans les 12 derniers mois, pièces à rotation lente avec une quantité vendue inférieure à 6 dans les 12 derniers mois, pièces à rotation moyenne avec une quantité vendue de 6 à 24 dans les 12 derniers mois, pièces à rotation rapide avec une quantité vendue de plus de 24 dans les 12 derniers mois.",
      "m0542": "La comparaison de profit de l'année à ce jour compare le profit de chaque mois de l'année en cours, représenté par des barres bleues, au profit faits au cours du même mois de l'année précédente, représenté par les barres vertes. Le pourcentage de croissance négatif ou positif est représenté par la ligne orange. Si l'une de ces barres est manquante, cela signifie que les données ne sont pas fournies ou que le mois n'est pas terminé.",
      "m0543": "Revenus des ventes du mois sélectionné de deux groupes de pièces principaux de Marchandises Générales (MG) et Pièces et Accessoires (P&A)",
      "m0544": "Croissance",
      "m0545": "Sélectionner une pièce",
      "m0546": "suggérée",
      "m0547": "%space%— vous pouvez modifier la commande avant de la soumettre. Par contre, nous recommandons fortement de commander tel que suggéré. La précision en croissance continuelle de SOM renforcera votre confiance à chaque commande. Vous pouvez modifier la quantité de pièces commandées dans la commande suggérée SOM en cours en modifiant la valeur affichée dans la colonne Qté à commander. ",
      "m0548": "en paquets si applicable",
      "m0549": "). Ce format est conçu pour importer vos commandes suggérées directement dans un bon de commande au sein de votre DMS (",
      "m0550": ").",
      "m0551": "si l'option d'importation de fichier CSV n'est pas pris en charge à l'écran de bon de commande de votre DMS",
      "m0552": "Tous les fournisseurs",
      "m0553": "Toutes les raisons d'ajustement",
      "m0554": "Tous les rôles",
      "m0555": "Toutes les organisations",
      "m0556": "Tous les pays",
      "m0557": "Toutes les langues",
      "m0558": "Toutes les devises",
      "m0559": "Tous les fuseaux horaires",
      "m0560": "Tous(tes) les états/provinces",
      "m0561": "Tous les types d'organisation",
      "m0562": "Tous les concessionnaires",
      "m0563": "Tous les groupes de rapports",
      "m0564": "Tous les statuts de pièces",
      "m0565": "Toutes les exceptions",
      "m0566": "Ne jamais commander",
      "m0567": "Min/Max stock",
      "m0568": "Saison",
      "m0569": "(Tous)",
      "m0570": "Utilisateur",
      "m0571": "Admin",
      "m0572": "Superadmin",
      "m0573": "BT - %var1%",
      "m0574": "Non",
      "m0575": "Aucun retour",
      "m0576": "Impossible de retrouver les détails de demandes de pièces de %var1%. Veuillez essayer de nouveau.",
      "m0577": "<1",
      "m0578": "Qté en commande",
      "m0579": "Qté disponible",
      "m0580": "Prévisions de demande 30 jours",
      "m0581": "Jan",
      "m0582": "Fév",
      "m0583": "Mar",
      "m0584": "Avr",
      "m0585": "Mai",
      "m0586": "Jun",
      "m0587": "Jul",
      "m0588": "Aoû",
      "m0589": "Sep",
      "m0590": "Oct",
      "m0591": "Nov",
      "m0592": "Déc",
      "m0593": "Total",
      "m0594": "Commande de pièces anticipée",
      "m0595": "Outil pour générer les commandes de pièces anticipées ",
      "m0596": "Commandes anticipées/retours",
      "m0597": "Hist. com. pièces anticipées",
      "m0598": "Commandes de pièces anticipées précédemment sauvegardées",
      "m0599": "Impossible de sauvegarder la commande de pièces anticipée",
      "m0600": "Groupe de pièces",
      "m0601": "Modifier la commande de pièces anticipée",
      "m0602": "Impossible de supprimer la commande de pièces anticipée",
      "m0603": "Supprimer",
      "m0604": "Voulez-vous supprimer cette commande de pièces anticipée?",
      "m0605": "Retour de pièces",
      "m0606": "Toutes les catégories",
      "m0607": "Catégorie de pièce :",
      "m0608": "Coût minimal :",
      "m0609": "Coût maximal :",
      "m0610": "Les coûts maximaux ne peuvent pas être moindres que les coûts minimaux!",
      "m0611": "Âge (mois) :",
      "m0612": "Vous devez sélectionner le filtre de catégorie de pièce!",
      "m0613": "Vous devez sélectionner le filtre d'âge!",
      "m0614": "Valeur minimale :",
      "m0615": "Valeur maximale :",
      "m0616": "La valeur maximale ne peut pas être moindre que la valeur minimale!",
      "m0617": "Âge (mois)",
      "m0618": "Qté de retour suggérée",
      "m0619": "Outil pour générer des retours de pièces",
  },
};



// WEBPACK FOOTER //
// ./src/localization/translation.js